import { render } from "./AppLayoutLinks.vue?vue&type=template&id=18843bbb"
import script from "./AppLayoutLinks.vue?vue&type=script&lang=js"
export * from "./AppLayoutLinks.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ayion/dev/dork/fmoj-vacms/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__